import {ellipsis} from 'ellipsed';

import {register} from '../vendor/theme-scripts/theme-sections';
import {modal} from '../util/modal';
import Media from '../features/media';
import {swatchSection} from '../features/swatch';
import {productAddSection} from '../features/product-add';
import {tooltipSection} from '../features/tooltip';
import pickupAvailability from '../features/pickup-availability';
import {productFormSection} from '../features/product-form';
import {productPhotoswipeZoom} from '../features/load-photoswipe';
import tabs from '../features/tabs';
import hideElement from '../util/hide-element';
import showElement from '../util/show-element';
import accordion from '../features/accordion';

const selectors = {
  productForm: '[data-product-form]',
  productJson: '[data-product-json]',
  popupButton: '[data-toggle-product-modal]',
  zoomButton: '[data-zoom-button]',
  toggleTruncateHolder: '[data-truncated-holder]',
  toggleTruncateButton: '[data-truncated-button]',
  toggleTruncateContent: '[data-truncated-content]',
  toggleTruncateContentAttr: 'data-truncated-content',
};

const classes = {
  classExpanded: 'is-expanded',
  classVisible: 'is-visible',
};

const sections = [];

class ProductTemplate {
  constructor(section) {
    this.section = section;
    this.id = section.id;
    this.container = section.container;
    this.settings = section.settings;
    this.productFormElement = this.container.querySelector(selectors.productForm);

    modal(this.id);
    this.media = new Media(section);

    const productJSON = this.container.querySelector(selectors.productJson);
    if (productJSON && productJSON.innerHTML !== '') {
      this.product = JSON.parse(productJSON.innerHTML);
    } else {
      console.error('Missing product JSON');
      return;
    }

    this.truncateElementHolder = this.container.querySelector(selectors.toggleTruncateHolder);
    this.truncateElement = this.container.querySelector(selectors.toggleTruncateContent);
    this.resizeEventTruncate = () => this.truncateText();

    this.init();
  }

  init() {
    this.zoomEnabled = this.container.querySelector(selectors.zoomButton) !== null;
    if (this.zoomEnabled) {
      productPhotoswipeZoom(this.container, this.product);
    }

    if (this.truncateElementHolder && this.truncateElement) {
      setTimeout(this.resizeEventTruncate, 50);
      document.addEventListener('theme:resize', this.resizeEventTruncate);
    }
  }

  truncateText() {
    if (this.truncateElementHolder.classList.contains(classes.classVisible)) return;
    const truncateRows = 5;
    const truncateElementCloned = this.truncateElement.cloneNode(true);
    const truncateElementClass = this.truncateElement.getAttribute(selectors.toggleTruncateContentAttr);
    const truncateNextElement = this.truncateElement.nextElementSibling;
    if (truncateNextElement) {
      truncateNextElement.remove();
    }

    this.truncateElement.parentElement.append(truncateElementCloned);

    const truncateAppendedElement = this.truncateElement.nextElementSibling;
    truncateAppendedElement.classList.add(truncateElementClass);
    truncateAppendedElement.removeAttribute(selectors.toggleTruncateContentAttr);

    showElement(truncateAppendedElement);

    ellipsis(truncateAppendedElement, truncateRows, {
      replaceStr: '',
    });

    hideElement(truncateAppendedElement);

    if (this.truncateElement.innerHTML !== truncateAppendedElement.innerHTML) {
      this.truncateElementHolder.classList.add(classes.classExpanded);
    } else {
      truncateAppendedElement.remove();
      this.truncateElementHolder.classList.remove(classes.classExpanded);
    }

    this.toggleTruncatedContent(this.truncateElementHolder);
  }

  toggleTruncatedContent(holder) {
    const toggleButton = holder.querySelector(selectors.toggleTruncateButton);
    if (toggleButton) {
      toggleButton.addEventListener('click', (e) => {
        e.preventDefault();
        holder.classList.remove(classes.classExpanded);
        holder.classList.add(classes.classVisible);
      });
    }
  }

  onBlockSelect(event) {
    const block = this.container.querySelector(`[data-block-id="${event.detail.blockId}"]`);
    if (block) {
      block.dispatchEvent(new Event('click'));
    }
  }

  onBlockDeselect(event) {
    const block = this.container.querySelector(`[data-block-id="${event.detail.blockId}"]`);
    if (block) {
      block.dispatchEvent(new Event('click'));
    }
  }

  onUnload() {
    this.media.destroy();
    if (this.truncateElementHolder && this.truncateElement) {
      document.removeEventListener('theme:resize', this.resizeEventTruncate);
    }
  }
}

const productSection = {
  onLoad() {
    sections[this.id] = new ProductTemplate(this);
  },
  onUnload() {
    if (typeof sections[this.id].unload === 'function') {
      sections[this.id].unload();
    }
  },
  onBlockSelect(evt) {
    if (typeof sections[this.id].onBlockSelect === 'function') {
      sections[this.id].onBlockSelect(evt);
    }
  },
  onBlockDeselect(evt) {
    if (typeof sections[this.id].onBlockDeselect === 'function') {
      sections[this.id].onBlockDeselect(evt);
    }
  },
};

register('product', [productSection, pickupAvailability, productFormSection, swatchSection, tooltipSection, productAddSection, accordion, tabs]);
